var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Chile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M44,24H24H4c0,11.046,8.954,20,20,20S44,35.046,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7dfe2",
    d: "M44,24c0-11.046-8.954-20-20-20v20H44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M24,4C12.954,4,4,12.954,4,24h20V4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.99,10.215L16.172,14H20l-3.096,2.149l1.182,3.667l-3.096-2.267l-3.096,2.267l1.182-3.667L9.98,14 h3.828L14.99,10.215z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Chile);
export default __webpack_public_path__ + "static/media/icons8-chile.2e3ddd9d851c768dca81df67305a2981.svg";
export { ForwardRef as ReactComponent };